import script from "./BookingAnnouncements.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingAnnouncements.vue?vue&type=script&setup=true&lang=js"

import "./BookingAnnouncements.vue?vue&type=style&index=0&id=c7d61062&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d61062"]])

export default __exports__